import { Injectable } from '@angular/core';
import { GatewayService } from '../../gateway.service';
import * as environment from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class LoginCpService {

  constructor(private readonly gatewayApis: GatewayService) { }

  public generateOTPApi(mobNum: any) {
    const body = {
      'SPTBGENERATEOTP': [
        {
          'x_mobile_no': mobNum
        }]
    };
    return this.gatewayApis.callApi(body, {})
  }

  public checkAuth(authData: any) {

    const body = {
      'AUTH2': [
        {
          'authType': 'O',
          'LOGIN_ID': authData.LOGIN_ID,
          'password': authData.password,
          'x_request_id': authData.beRequestID
        }]
    };
    return this.gatewayApis.callApi(body, {})
  }

  public auth_vahana(authData: any, header?: string) {   // Not in use
    const body = {
      'AUTH_VAHANA': [
        {
          'LOGIN_ID': authData.LOGIN_ID,
          'id': authData.LOGIN_ID
        }]
    };
    const headers = header ? { isforcelogin: 'Y' } : {}
    return this.gatewayApis.callApi(body, headers)
  }

  public getUserSession(authData: any) {

    const body = {
      'SPDPGETUSERSESSION': [
        {
          'LOGIN_ID': authData.LOGIN_ID
        }]
    };
    return this.gatewayApis.callApi(body, {})
  }

  public getUserObject(authData: any) {      // Not in use 

    const body = {
      'SPGETCPUSEROBJECT': [
        {
          'x_mobile_no': authData.LOGIN_ID,
          'x_cp_code': authData.cp_code,
          'x_cp_user_id': authData.cp_user_id,
          'x_user_id': authData.LOGIN_ID
        }]
    };
    return this.gatewayApis.callApi(body, {})
  }

  public sendOTPViaWhatsapp(number,otp) {
    const body = {
      'SR-SEND_WHATSAPP_AUTHENICATIONOTP_MESSAGE': [
        {
          "to": number,
          "templateId": "crif_otp",
          "recipientType": "individual",
          "parameterValues": otp,
        }],
    };
    return this.gatewayApis.callApi(body, {})
  }

  public whatsappOptIn(mobileNumber: string, consent: string) {
    const body = {
      'USER_OPTIN': [{
        'mobileNo': '91' + mobileNumber,
        'x_type': 'CP',
        'x_consent': 'Y',
        'x_key_object_data': '1'
      }]
    };
    return this.gatewayApis.callApi(body, {});
  }

  public generateByPassOtp(mobile_num: any) {
    const body = {
      'SPTBGENERATEBYPASSOTP': [
        {
          'x_mobile_no': mobile_num,
          'x_group_id': 'MOBILE_CP_PORTAL_LOGIN_OTP',
          'x_filter_property': 'NA'

        }]
    };
    return this.gatewayApis.callApi(body, {})
  }

  spInsUpdCpLedgerChecking(loginData) {
    let appId = environment.environment['envProps']['appId']
    const body = {
      SPINSUPDCPLEDGERCHECKING: [{
        x_cp_code: loginData.CP_CODE,
        x_flag: '',
        x_app_id: appId
      }]
    }
    console.log('sp_ins_upd_cp_inv_setting_checking body', body);
    return this.gatewayApis.callApi(body, {});
  }

  spSetInvoiceMode(mode,eventType,loginData) {
    const body = {
      SPINSUPDCPINVSETTING: [{
        x_cp_code: loginData.CP_CODE,
        x_flag: mode,
        x_event_type : eventType

      }]
    }
    return this.gatewayApis.callApi(body, {});
  }
}



